<template>
    <div>
        <div class="container">
            <data-table
                :columns="columns"
                :filters="filters"
                :classes="classes"
                :per-page="perPage"
                :debounce-delay=1000
                url="/api/get-users"
                ref="userTable">
<!--                @loading="isLoading = true"-->
<!--                @finished-loading="isLoading = false">-->
                <div slot="filters" slot-scope="{ tableFilters, perPage }">
                    <div class="row mb-2">
                        <div class="col-md-2">
                            <select class="form-control" v-model="tableFilters.length">
                                <option :key="page" v-for="page in perPage">{{ page }}</option>
                            </select>
                        </div>
                        <div class="col-md-5" id="additional-option">
                        <button class="btn btn-primary btn-sm"  @click="showModal = true">
                           Register Account
                        </button>
                        </div>
                        <div class="col-md-2">
                            <select class="form-control" v-model="tableFilters.filters.status">
                                <option value>All</option>
                                <option value="1">Active</option>
                                <option value="2">Inactive</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <input
                                name="name"
                                class="form-control"
                                v-model="tableFilters.filters.search"
                                placeholder="Search">
                        </div>
                    </div>
                </div>
                <tbody slot="body" slot-scope="{ data }">
                    <tr
                        :key="item.id"
                        v-for="item in data" :class="{
                            'stripe-payment': item.payment_type === 'stripe' && trialStatusMap[item.user_name] || !trialStatusMap[item.user_name],
                            'trial': trialStatusMap[item.user_name] === 1 && item.payment_type !== 'stripe',
                            'bg-white': !trialStatusMap[item.user_name] && (!item.payment_type || (item.payment_type !== 'stripe' && trialStatusMap[item.user_name] !== 1)),
                         }">
                        <td
                            :key="column.name"
                            v-for="column in columns" :class="{italic : !item.active}">
                            <data-table-cell
                                :value="item"
                                :name="column.name"
                                :meta="column.meta"
                                :event="column.event"
                                :handler="column.handler"
                                :comp="column.component"
                                :classes="column.classes">
                            </data-table-cell>
                        </td>
                    </tr>
                </tbody>
            </data-table>

            <div class="legends">
                <div class="mb-2"><span class="stripe-payment"></span> Stripe Subscriptions</div>
                <div class="mb-2"><span class="trial"></span> With Trial Access</div>
                <div ><span class="deactivated">text</span> Deactivated Accounts</div>
            </div>
        </div>

        <Loading :is-full-page="true" :active.sync="isLoading"/>
        <PopupAddSubscriber :showModal="showModal" @close="closeModal" @reloadUserTable="reloadUserTable" :updateAccess="updateAccess" :addPaymentType="addPaymentType" :notifyTrial="notifyTrial" ref="PopupAddSubscriber" :data="selectedRow" @message="message"/>
        <AlertModal :showAlertModal="showAlertModal" @close="closeAlertModal" :data="this.messageValue"/>
    </div>
</template>

<script>
import PopupAddSubscriber from "./PopupAddSubscriber";
import CancelSubscriptionButton from "./CancelSubscriptionButton";
import GroupAccessItem from "./GroupAccessItem";
import PaymentTypeItem from "./PaymentTypeItem";
import AddGroupAccessButton from "./AddGroupAccessButton";
import AlertModal from "./AlertModal";
import Loading from "./Loading";
import axios from "axios";

export default {
    data() {
        return {
            trialStatusMap: {},
            isLoadingUserData: false,
            isLoading: false,
            showModal: false,
            updateAccess: false,
            addPaymentType: false,
            notifyTrial: false,
            showAlertModal: false,
            messageValue:'',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            perPage: ['25','50'],
            classes: {
                "table": {
                    "table-striped": false,
                },
                "td": {
                    'in-active': true
                },
            },
            columns: [
                {
                    label: 'Email',
                    name: 'user_name',
                    orderable: true,
                },
                {
                    label: 'Name',
                    name: 'full_name',
                    orderable: true,
                },
                {
                    label: 'Company name',
                    name: 'company_name',
                    orderable: true,
                },
                {
                    label: 'Phone number',
                    name: 'phone_number',
                    orderable: true,
                },
                {
                    label: 'Demo Call',
                    name: 'onboard_demo_call',
                    orderable: true,
                },
                {
                    label: 'Subscription Plan',
                    event: "click",
                    handler: this.removeGroupAccess,
                    component: GroupAccessItem,
                    orderable: true,
                },
                {
                    label: '',
                    orderable: false,
                    event: "click",
                    handler: this.addGroupAccess,
                    component: AddGroupAccessButton
                },
                {
                    label: 'Created Date',
                    name: 'date_created',
                    orderable: true,
                },

                {
                    label: '',
                    orderable: false,
                    event: "click",
                    handler: this.displayRow,
                    component: CancelSubscriptionButton
                },
            ],
            filters: {
                status:'',
                search:'',
            },
            selectedRow: {},

        }
    },
    components: {
        PopupAddSubscriber,
        Loading,
        AddGroupAccessButton,
        PaymentTypeItem,
        AlertModal,
    },
    methods: {
        message(msg){
            this.showModal = false;
            this.showAlertModal = true;
            this.messageValue = msg;
        },
        displayRow(data,value) {
            if(data =="alert"){
                this.message(value, false);
                return;
            }
            if(value) {
                this.selectedRow = data;
                this.$refs.PopupAddSubscriber.setNotifyInfo(this.selectedRow);
                this.showModal = true;
                this.notifyTrial = true;
            } else {
                let self = this;
                let action = (data.active) ? "deactivate" : "reactivate";

                let confirmation = confirm(`Are you sure you want to ${action} this user ${data.user_name}?`);
                if(!confirmation) return false;

                if(action == "deactivate") {
                    // alert(`active  ${}`);
                    axios.post('/api/deactivate-user', {
                        user_name: data.user_name,
                        __token: this.csrf
                    })
                    .then((response) => {
                        this.$nextTick(() => {
                            this.reloadUserTable();
                        });
                    }, (error) => {
                        console.log(error);
                    });
                } else {
                    // alert(`not active ${data.user_name}`);
                    axios.post('/api/reactivate-user', {
                        user_name: data.user_name,
                        __token: this.csrf
                    })
                    .then((response) => {
                        this.$nextTick(() => {
                            this.reloadUserTable();
                        });
                    }, (error) => {
                        console.log(error);
                    });
                }
            }

        },

        reloadUserTable() {
            this.$refs.userTable.getData();
        },

        removeGroupAccess(username, ga) {
            let confirmation = confirm(`Are sure do you want to remove the "${ga}" access from ${username}?`);
            if(!confirmation) return false;

            axios.post('/api/remove-group-access', {
                user_name: username,
                group_access: ga,
            })
            .then((response) => {
                let data = response.data;
                this.$nextTick(() => {
                    let msg = {
                        header: 'Successfully Deleted',
                        message:`The <b>"${ga}"</b> access has been deleted.`,
                    };
                    this.message(msg);
                });
            }, (error) => {
                console.log(error);
            });
        },
        addGroupAccess(data) {
            this.selectedRow = data;
            this.$refs.PopupAddSubscriber.setExistingAccess(this.selectedRow);
            this.showModal = true;
            this.updateAccess = true;
        },
        addPaymentTypes(data) {
            this.selectedRow = data;
            this.$refs.PopupAddSubscriber.setAddPaymentInfo(this.selectedRow);
            this.showModal = true;
            this.addPaymentType = true;
        },
        closeModal() {
            //for PopupAddSubscriber
            this.showModal = false;
            this.updateAccess = false;
            this.addPaymentType = false;
            this.notifyTrial = false;
            this.$refs.PopupAddSubscriber.closeModal();
        },
        closeAlertModal(reload) {
            this.showAlertModal = false;
            if(reload != false) {
                this.$refs.PopupAddSubscriber.defaultLabel();
            }

        },

        async fetchUserData() {
            this.isLoading = true;
            try {
                const response = await axios.get(`/api/get-all-user-trial-account`);
                const trialUsers = response.data;

                trialUsers.forEach(user => {
                    const trialStatus = user.status;
                    this.$set(this.trialStatusMap, user.email, trialStatus);
                });

            } catch (error) {
                console.error('Error fetching user data:', error);
                throw error;
            } finally {
                this.isLoading = false;
            }
        }


    },
    mounted: function (){
        this.fetchUserData()
    },

}
</script>

<style lang="scss" scoped>
    #additional-option {
        display: flex;
        justify-content: flex-end;
    }
    .italic {
        color: #7b7878;
        font-style: italic;
    }
    .stripe-payment {
        background: rgb(176 171 247 / 19%);
    }
    .invoice {
        background: rgb(245 245 127 / 12%);
    }

    .trial {
        background : rgb(189 184 184 / 47%);
    }
    .legends {
        div {
            display: flex;

            span {
                width: 20px;
                height: 20px;
                display: block;
                margin-right: 10px;
                border: 1px solid #ababb9;

                &.deactivated {
                    font-style: italic;
                    color: #7b7878;
                    border: none;
                    margin-right: 15px;
                }
            }
        }
    }
</style>
